module.exports = __webpack_public_path__ + "img/jo1.f451a71e.png";